import { render, staticRenderFns } from "./ClientDealList.vue?vue&type=template&id=7d36e6a5&"
import script from "./ClientDealList.vue?vue&type=script&lang=ts&"
export * from "./ClientDealList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports